import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { AdminPanel } from '../components/AdminPanel';
import { toast } from 'sonner';

export default function Admin() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  // Admin auth guard: only administrators may access this route.
  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      toast.info('Authorization Required', { description: 'Please sign in as an administrator.' });
      navigate('/auth');
    } else if (user.role !== 'admin') {
      toast.error('Access Denied', { description: 'This area is restricted to administrators.' });
      navigate('/dashboard');
    }
  }, [user, authLoading, navigate]);

  if (authLoading || !user || user.role !== 'admin') {
    return (
      <div className="min-h-screen bg-luxury-black text-white flex items-center justify-center font-serif-luxury text-luxury-gold tracking-[0.3em] animate-pulse">
        VERIFYING ADMIN CLEARANCE...
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-luxury-black text-white py-12 px-6 md:px-12 lg:px-24" data-testid="admin-route">
      <div className="max-w-6xl mx-auto">
        <div className="border-b border-white/10 pb-8 mb-10">
          <h1 className="text-3xl md:text-5xl font-serif-luxury text-white">
            Admin <span className="italic text-luxury-goldLight">Control Room</span>
          </h1>
          <p className="text-xs text-luxury-muted mt-2 font-sans-luxury">
            Signed in as {user.email} — manage everything without code.
          </p>
        </div>
        <AdminPanel />
      </div>
    </div>
  );
}
